import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Footer from "../../Common/Footer";
import RequireLogin from "../../../permissions.js/RequireLogin";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import SideMenu from "../SideMenu";
import Card from "./Card";
import WMAccounts from "../../../SVGs/WMAccounts.svg";
import Nav from "../../Common/Nav";
import NothingToShow from "../../Common/NothingToShow";
import Cookies from "js-cookie";
import PageLoader from "../../Common/PageLoader";

function Accounts() {
  const [isLoading, setIsLoading] = useState(false);
  const [accounts, setAccount] = useState();

  useEffect(() => {
    const userid = Cookies.get("hippocratic_portal_contactid");
    setIsLoading(true);

    getApiClient()
      .getActiveWMAccountsUOM(userid)
      .then((res) => {
        setAccount(res.data);
      })
      .catch(
        makeStandardApiErrorHandler((error) => {
          console.log(error);
        })
      )
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <TopSection>
          <NavigationInformation>
            Home &gt; My Profile &gt; Wealth Management Accounts
          </NavigationInformation>
          <Title>Wealth Management Accounts</Title>
        </TopSection>
        <BottomSection>
          <SideMenu />
          {accounts && accounts.length > 0 ? (
            <RightContainer>
              <Card
                Title="List of Accounts"
                accounts={accounts}
                Icon={WMAccounts}
              />
            </RightContainer>
          ) : (
            <NothingToShow
              background={"#E8F6F7"}
              text="You don't have any wealth management accounts with Hippocratic"
            />
          )}
        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  padding: 0px 5vw;
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const NavigationInformation = styled.div`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  gap: 30px;
`;

const RightContainer = styled.div`
  display: flex;
  backgorund-color: #d4eef0;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

export default RequireLogin(Accounts);
